import styled from '@emotion/styled'
import {Slider} from '@mui/material'
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip'

export const StyledSlider = styled(Slider)(({theme}) => ({
  color: theme.palette.primary.main,
  height: 4,
  '& .MuiSlider-track': {
    border: 'none'
  },
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    backgroundColor: theme.palette.hpWhite,
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit'
    },
    '&::before': {
      display: 'none'
    }
  }
}))

export const StyledTooltip = styled(({className, ...props}) => <Tooltip {...props} classes={{popper: className}} />)(
  () => ({
    [`& .${tooltipClasses.tooltip}`]: {
      borderRadius: '4px'
    }
  })
)
